import { SVGProps, Ref, forwardRef } from 'react';

export const HomeFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m7.893 1 6.4 6.4H23.4L17 1zm-1.677.868L0 8.75V15c0 6 2 8 8 8h5.1V8.753zM14.9 23H16c6 0 8-2 8-8V9.2h-9.1z"
                fill="currentColor"
            />
        </g>
    </svg>
));
HomeFilledSize24Glyph.displayName = 'HomeFilledSize24Glyph';
